const filter_counter = document.querySelector("#FilterCounter .counter");
let isRunning = false;
let slider = "";
let sliderIterationNr = 0;
function toggleFilterWidget() {
  document.getElementById("FilterWidget").classList.toggle("fixed");
  document.querySelector("#FilterCounter .bg").classList.toggle("collapsed");
}
window.addEventListener("DOMContentLoaded", function (event) {
    const footer = document.querySelector('.subscription_block');
      footer.previousElementSibling.classList.add('removeOnMob');
      footer.nextElementSibling.nextElementSibling.classList.add('additionalMark')
});
window.addEventListener("load", () => {
  const filterIcon = document.querySelector(".bg");
  gsap.registerPlugin(ScrollTrigger)

ScrollTrigger.create({
	trigger: '.menu-column',
	animation: gsap.fromTo('.bg', {scale: 1 }, {scale: 2}),
	start: 'center center',
	end: 'bottom top',
  scrub: true
})
  // window.addEventListener("scroll", function () {
  //   var currScrollPos2 = document.documentElement.scrollTop;
  //   var start = window.innerHeight / 2;
  //   if (currScrollPos2 > start) {
  //     if (currScrollPos2 / start + 2 <= 4) {
  //       filterIcon.style.transform =
  //         "translate(-50%, -50%) scale(" + currScrollPos2 / start + 2 + ")";
  //     }
  //   }
  // });
 
});

function runSlider(e) {
  sliderIterationNr = 0;
  let img_container = e.target.querySelector(".imgs");
  let pictures = img_container.querySelectorAll("picture");
  if (isRunning == false) {
    isRunning = true;
    slider = setInterval(function () {
      if (
        sliderIterationNr <= pictures.length - 1 &&
        !e.target.classList.contains("fullyLoaderSlider")
      ) {
        pictures.forEach((picture) => {
          if (
            !picture.classList.contains("active") &&
            !picture.classList.contains("preload")
          ) {
            picture.classList.add("preload");
          }
        });
        if (sliderIterationNr == pictures.length - 1) {
          e.target.classList.add("fullyLoaderSlider");
        }
      } else {
        if (sliderIterationNr == pictures.length + 1) {
          pictures.forEach((picture) => {
            if (!picture.classList.contains("active")) {
              picture.classList.remove("preload");
            }
          });
        }
        var c = img_container.querySelector(".active");
        var n = img_container.querySelector(".active").nextElementSibling;
        if (!img_container.querySelector(".active").nextElementSibling) {
          n = img_container.querySelectorAll("picture")[0];
        }
        c.classList.remove("active");
        n.classList.add("active");
      }
      sliderIterationNr = sliderIterationNr + 1;
    }, 400);
  }
}
function stopSlider() {
  sliderIterationNr = 0;
  if (isRunning == true) {
    clearInterval(slider);
    slider = "";
    isRunning = false;
  }
}
let storyTimeout;
function openStories(url) {
  var request = new XMLHttpRequest();
  request.open("GET", url, true);
  request.onload = function () {
    if (request.status >= 200 && request.status < 400) {
      var resp = request.responseText;
      var parser = new DOMParser();
      var htmlDoc = parser.parseFromString(resp, "text/html");
      var stories = htmlDoc.getElementById("StoriesPageWrapper");
      var body = document.querySelector("body");
      body.appendChild(stories);
      var storiesArray = (storiesArray = document.querySelectorAll(
        ".slide-items .story"
      ));
      var thumbsArray = [...Array(storiesArray.length).keys()];
      const thumbsWrapper = document.querySelector(".slide-thumb");
      thumbsArray.forEach((thumb) => {
        var span = document.createElement("span");
        span.setAttribute("class", "thumb_" + thumb);
        thumbsWrapper.appendChild(span);
      });
      body.querySelector(".slide-items .story").classList.add("active");
      body.querySelector(".slide-thumb span").classList.add("active");
      body.querySelector("#FilterCounter").classList.add("hidden");
      document.querySelector("header button.close").classList.add("show");
      document.querySelector("button.slide-prev").classList.add("hide");
      storyTimeout = setTimeout(function () {
        document.querySelector(".slide-next").click();
      }, 8000);
    } else {
    }
  };
  request.onerror = function () {};
  request.send();
}
function closeStories() {
  document.querySelector("#StoriesPageWrapper").remove();
  document.querySelector("#FilterCounter").classList.remove("hidden");
  document.querySelector("header button.close").classList.remove("show");
  clearTimeout(storyTimeout);
}
document.addEventListener("keydown", function (e) {
  const key = e.key;
  switch (key) {
    case "ArrowLeft":
      document.querySelector("button.slide-prev").style = "background: #0F52FB";
      setTimeout(function () {
        document.querySelector("button.slide-prev").style = "";
      }, 150);
      prevSlide();
      break;
    case "ArrowRight":
      document.querySelector("button.slide-next").style = "background: #0F52FB";
      setTimeout(function () {
        document.querySelector("button.slide-next").style = "";
      }, 150);
      nextSlide();
      break;
  }
});
function nextSlide() {
  let next2 = null;
  const next = document.querySelector(
    ".slide-items .story.active"
  ).nextElementSibling;
  if (next) {
    next2 = document.querySelector(".slide-items .story.active")
      .nextElementSibling.nextElementSibling;
  }
  const next_thumb = document.querySelector(
    ".slide-thumb span.active"
  ).nextElementSibling;
  document
    .querySelector(".slide-items .story.active")
    .classList.remove("active");
  document.querySelector(".slide-thumb span.active").classList.remove("active");
  clearTimeout(storyTimeout);
  storyTimeout = setTimeout(function () {
    document.querySelector(".slide-next").click();
  }, 8000);
  if (next != null && next2 != null) {
    next.classList.add("active");
    next_thumb.classList.add("active");
    if (
      document.querySelector("button.slide-next").classList.contains("hide")
    ) {
      document.querySelector("button.slide-next").classList.remove("hide");
    }
    if (
      document.querySelector("button.slide-prev").classList.contains("hide")
    ) {
      document.querySelector("button.slide-prev").classList.remove("hide");
    }
  } else if (next != null && next2 == null) {
    next.classList.add("active");
    next_thumb.classList.add("active");
    document.querySelector("button.slide-next").classList.add("hide");
  } else closeStories();
}
function prevSlide() {
  let prev2 = null;
  const prev = document.querySelector(
    ".slide-items .story.active"
  ).previousElementSibling;
  if (prev) {
    prev2 = document.querySelector(".slide-items .story.active")
      .previousElementSibling.previousElementSibling;
  }
  const prev_thumb = document.querySelector(
    ".slide-thumb span.active"
  ).previousElementSibling;
  const storiesArray = document.querySelectorAll(".slide-items .story");
  const thumbsArray = document.querySelectorAll(".slide-thumb span");
  document
    .querySelector(".slide-items .story.active")
    .classList.remove("active");
  document.querySelector(".slide-thumb span.active").classList.remove("active");
  clearTimeout(storyTimeout);
  storyTimeout = setTimeout(function () {
    document.querySelector(".slide-next").click();
  }, 8000);
  if (prev != null && prev2 != null) {
    prev.classList.add("active");
    prev_thumb.classList.add("active");
    if (
      document.querySelector("button.slide-prev").classList.contains("hide")
    ) {
      document.querySelector("button.slide-prev").classList.remove("hide");
    }
    if (
      document.querySelector("button.slide-next").classList.contains("hide")
    ) {
      document.querySelector("button.slide-next").classList.remove("hide");
    }
  } else if (prev != null && prev2 == null) {
    prev.classList.add("active");
    prev_thumb.classList.add("active");
    document.querySelector("button.slide-prev").classList.add("hide");
  } else {
    closeStories();
  }
}
const hideEmail = (cl) => {
  let a = cl + ' #mce-EMAIL';
  document.querySelector(a).parentNode.classList.add('paused')
}
const showEmail = (cl) => {
  let a = cl + ' #mce-EMAIL';
  if ( 
    document.querySelector(a).value == "") {
    document.querySelector(a).parentNode.classList.remove('paused')
  }
}
